/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Usecases_TitleInputs */

const es_home_usecases_title = /** @type {(inputs: Home_Usecases_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Casos de uso`)
};

const en_home_usecases_title = /** @type {(inputs: Home_Usecases_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use cases`)
};

/**
* | output |
* | --- |
* | "Use cases" |
*
* @param {Home_Usecases_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_usecases_title = /** @type {((inputs?: Home_Usecases_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Usecases_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_usecases_title(inputs)
	return en_home_usecases_title(inputs)
});
export { home_usecases_title as "home.usecases.title" }